<template>
  <footer v-if="platform === 'BROWSER'" id="footer-view">
    <div class="items-footer" v-bind:class="this.$route.name === 'Resorts' ? 'items-home' : ''">
      <router-link to="/" class="ria-link">{{ $t("footer.home") }}</router-link>
      <div class="inline-block" v-if="resort">
        <span @click="selectModal(page.id)" class="ria-link" v-for="page in resort.pages" :key="page.id">{{translate(page, 'name')}}</span>
      </div>
      <a :href="urlPrivacy" class="ria-link">{{ $t("review.privacy") }}</a>
      <a href="javascript:Cookiebot.show()" class="ria-link">{{ $t("cookie.policy") }}</a>
      <locale-select class="ml-5 mr-5 uppercase text-1xs px-2 py-1" />
    </div>
    <modal :closeButtonText="i18n.t('review.ok')" @close="modal" v-if="showModal">
      <div slot="title">
          <span>{{translate(pageSelected, 'name')}}</span>
      </div>
      <div class="text-justify px-3" slot="body">
          <span class="whitespace-pre-line" v-html="translate(pageSelected, 'description')"></span>
      </div>
    </modal>
  </footer>
</template>

<script>
import { mapGetters } from 'vuex';
import Modal from "@/components/common/modal";
import { translate }  from '@/helpers/translationsHelpers.js';
import i18n from '../../i18n';

export default {
  name: "ria-footer",
  data: function(){
    return {
      showModal: false,
      pageSelected: null,
      i18n: i18n
    }
  },
  components: {
      Modal
  },
  computed: {
    ...mapGetters('device', ['language', 'platform']),
    ...mapGetters('resort', ['resort']),
    urlPrivacy: function(){
      return `https://www.skitude.com/${this.language}/terms-and-conditions?x_skitude_external_page=true`
    }
  },
  methods: {
    modal: function(){
      this.showModal = !this.showModal
    },
    selectModal: function(option) {
      this.pageSelected = this.resort.pages.find(page => page.id === option)
      this.modal()
    },
    translate(object, field) {
      return translate(object, field)
    },
  }
};
</script>

<style scoped>

  footer {
    @apply text-center;
  }

  .items-footer {
    @apply items-center py-10 text-center bg-grey-bg !important;
  }

  .ria-link {
    @apply m-3 font-light text-1xs cursor-pointer text-grey-subtitle;
  }

  @screen lg {
    .items-footer {
      @apply border-grey-border border-t-1 pt-5 pb-40;
    }

    .items-home {
      @apply bg-white !important;
    }
  }
</style>
